<template>
  <div class="stores-list">
    <vue-client-only>
      <div
        v-if="!adaptive.isMobile"
        class="legend"
      >
        <span class="legend-address">
          Адрес
        </span>
        <span class="legend-format">
          Формат
        </span>
        <span class="legend-schedule">
          Часы работы
        </span>
      </div>
    </vue-client-only>
    <div
      v-if="stores.length"
      class="list"
    >
      <div
        v-for="store in stores"
        :key="store.id"
        class="item"
      >
        <div class="contacts">
          <div
            class="metro"
          >
            <div
              v-for="metro in store.metro"
              :key="metro.id"
            >
              <span :style="{backgroundColor: metro.line.color}" />{{ metro.name }}
            </div>
          </div>
          <div class="address">
            {{ store.address }}
          </div>
          <div class="phone">
            <span>Телефон:</span> {{ store.phone | noBracesPhone }}
          </div>
        </div>
        <div class="format">
          <span>Формат:</span> {{ store.workMode || '' }}
        </div>
        <div class="schedule">
          <span>Часы работы:</span> {{ store | parseWorkSchedule }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueClientOnly from 'vue-client-only';

export default {
  name: 'stores-list',

  components: {
    VueClientOnly,
  },

  inject: ['adaptive'],

  props: {
    stores: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.stores-list {
  .list {
    margin-top: 17px;

    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background-color: $gray-lu;
    }
  }

  .item {
    padding: 16px 12px;
    border-bottom: 1px solid $gray_lu;
  }

  .contacts {
    .metro,
    .phone {
      font-size: 12px;
      line-height: 20px;
    }

    .address,
    .phone {
      margin-top: 4px;
    }

    .metro {
      display: flex;
      flex-wrap: wrap;
    }

    .metro > div {
      display: flex;
      align-items: center;
      margin-right: 12px;

      & > span {
        display: block;
        width: 8px;
        height: 8px;
        margin-right: 8px;
        border-radius: 50%;
      }
    }

    .address {
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
    }

    .phone {
      span {
        color: $gray;
      }
    }
  }

  .format,
  .schedule {
    font-size: 12px;
    line-height: 20px;

    span {
      color: $gray;
    }
  }
}

@include breakpoint("tablet") {
  .stores-list {
    margin-top: 4px;

    .legend {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0 16px 12px;
      color: $gray;
      font-size: 12px;
      line-height: 16px;

      &-address {
        width: 360px;
      }

      &-address,
      &-format {
        margin-right: 28px;
      }

      &-format {
        width: 136px;
      }

      &-schedule {
        width: 140px;
      }
    }

    .list {
      margin-top: 0;
    }

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0 12px 12px;
    }

    .contacts {
      width: 360px;

      .phone {
        margin-top: 2px;
      }
    }

    .contacts,
    .format {
      margin-right: 28px;
    }

    .schedule,
    .format {
      width: 136px;
      span {
        display: none;
      }
    }

    .schedule {
      width: 140px;
    }
  }
}

@include breakpoint("desktop") {
  .stores-list {
    margin-top: 16px;

    .legend {
      font-size: 14px;
      padding: 20px 0 20px 16px;

      &-address {
        width: 574px;
        margin-right: 182px;
      }

      &-format {
        margin-right: 77px;
      }

      &-format,
      &-schedule {
        width: 184px;
      }
    }

    .item {
      padding: 20px 0 20px 20px;
    }

    .contacts {
      width: 574px;
      margin-right: 182px;
      .metro,
      .address,
      .phone {
        line-height: 24px;
      }

      .metro,
      .phone {
        font-size: 14px;
      }

      .address {
        font-size: 16px;
      }
    }

    .format {
      margin-right: 80px;
    }

    .format,
    .schedule {
      width: 184px;
      font-size: 14px;
      line-height: 24px;
    }
  }
}
</style>